var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61435 2.77292C7.04719 1.69505 7.26362 1.15611 7.5728 0.996883C7.84095 0.858787 8.1593 0.858787 8.42745 0.996882C8.73664 1.15611 8.95306 1.69505 9.3859 2.77291L10.414 5.33302L13.1665 5.51965C14.3253 5.59823 14.9048 5.63752 15.1517 5.88236C15.3659 6.09471 15.4643 6.39749 15.4158 6.69518C15.3599 7.03844 14.9143 7.41081 14.0229 8.15555L11.9058 9.92441L12.5789 12.5999C12.8622 13.7263 13.0039 14.2895 12.8474 14.6001C12.7116 14.8694 12.4541 15.0565 12.156 15.1024C11.8122 15.1553 11.3204 14.8465 10.3366 14.2289L8.00013 12.762L5.66361 14.2289C4.67988 14.8465 4.18801 15.1553 3.84429 15.1024C3.54618 15.0565 3.28863 14.8694 3.15286 14.6001C2.99632 14.2895 3.13801 13.7263 3.42139 12.5999L4.09445 9.92441L1.97734 8.15555C1.08598 7.41081 0.640303 7.03844 0.58441 6.69518C0.535935 6.39749 0.634312 6.09471 0.848512 5.88236C1.09549 5.63752 1.67493 5.59823 2.8338 5.51965L5.58629 5.33302L6.61435 2.77292Z",
    fill: "#FF8833"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.32c7bb23dba340abe4af186fb8de400a.svg";
export { ForwardRef as ReactComponent };